/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import tinycolor from 'tinycolor2';
import { useLocation } from 'react-router';

import Button from '../../shared/_TBComponents/Button';
import HeaderText from '../../shared/_TBComponents/HeaderText';
import ViewOnlyOverview from './components/presentational/ViewOnlyOverview';
import ViewOnlyAnalysis from './components/presentational/ViewOnlyAnalysis';
import LightLogo from '../../shared/images/poweredByTBWhite.png';
import DarkLogo from '../../shared/images/poweredByTBBlack.png';
import Spinner from '../../shared/_TBComponents/Spinner';
import InvalidTokenModal from '../sport-coach-dashboard/components/presentational/InvalidTokenModal';
import { fetchPublicVBTData, setAboutVBTDashModal, setVBTDashView } from './ducks/vbtDashboardActions';
import SharedTemplateAboutModal from '../sports-science/components/presentational/sharedTemplateComponents/SharedTemplateAboutModal';

const Container = styled('div')`
  width: 100%;
`;

const DashboardBanner = styled('div')`
  align-items: center;
  background-color: ${(props) => props.bgColor};
  color: #FFFFFF;
  display: flex;
  height: 100px;
  justify-content: space-between;
  padding: 10px 15px;
`;

const DashboardHeader = styled('div')`
  align-items: flex-end;
  background-color: #FFFFFF;
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  padding-top: 30px;
  width: 100%;
`;

const MenuContainer = styled('div')`
  display: flex;
`;

const MenuItem = styled('button')`
  border: none;
  border-bottom: ${(props) => (props.isActive ? '3px solid #1787FB!important' : '3px solid white')};
  color: ${(props) => (!props.isActive ? '#9E9E9E' : '#444444')};
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  margin-left: 10px;
  margin-right: 12px;
`;

const PageWrapper = styled('div')`
  background: #F5F5F5;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TBuildrLogo = styled('div')`
  background-image: ${(props) => (tinycolor(props.bgColor).isLight()
    ? `url(${DarkLogo})`
    : `url(${LightLogo})`)};
  background-repeat: no-repeat;
  height: 46px;
  width: 200px;
`;

const TitleAndInfo = styled('div')`
  display: flex;

  button {
    margin-left: 5px;
  }

  svg {
    border: 1px solid #808080;
    border-radius: 50%;
    height: 20px;
    padding: 3px;
    width: 20px;
  }
`;

const UserLogo = styled('img')`
  height: 75px;
`;

const Wrapper = styled('div')`
  height: 100%;
`;

const ViewOnlyVBTDashboard = () => {
  const aboutModalShowing = useSelector(
    (state) => state.vbtDashboard.ui.aboutModalShowing,
  );
  const dashBGColor = useSelector((state) => state.vbtDashboard.data.dashBGColor);
  const dashLogo = useSelector((state) => state.vbtDashboard.data.dashLogo);
  const dashTitle = useSelector((state) => state.vbtDashboard.data.dashTitle);
  const vbtData = useSelector((state) => state.vbtDashboard.data.vbtData);
  const vbtError = useSelector((state) => state.vbtDashboard.data.vbtError);
  const vbtDashView = useSelector((state) => state.vbtDashboard.ui.vbtDashView);

  const location = useLocation();
  const token = new URLSearchParams(location.search).get('token');

  const dispatch = useDispatch();

  // Fetch data on page load with token if there's no data
  useEffect(() => {
    dispatch(fetchPublicVBTData(null, token));
  }, []);

  const handleMenuClick = (view) => {
    if (view !== vbtDashView) {
      dispatch(setVBTDashView(view));
    }
  };

  return (
    <Container>
      <Helmet>
        <title>VBT Dashboard | TeamBuildr</title>
      </Helmet>
      {vbtError && (
        <InvalidTokenModal />
      )}
      {!vbtData ? (
        <Wrapper>
          <Spinner />
        </Wrapper>
      ) : (
        <PageWrapper>
          <DashboardBanner bgColor={dashBGColor}>
            <UserLogo src={dashLogo} alt='user logo' id='userLogo' />
            <TBuildrLogo bgColor={dashBGColor} />
          </DashboardBanner>
          <DashboardHeader>
            <TitleAndInfo>
              <HeaderText
                fontWeight='300'
                letterSpacing='normal'
              >
                {dashTitle}
              </HeaderText>
              <Button
                iconOnly
                icon='info'
                noBorder
                onClick={() => dispatch(setAboutVBTDashModal(true))}
                rounded
              />
            </TitleAndInfo>
            <MenuContainer>
              <MenuItem
                isActive={vbtDashView === 'overview'}
                onClick={() => handleMenuClick('overview')}
              >
                Performance Overview
              </MenuItem>
              <MenuItem
                isActive={vbtDashView === 'group'}
                onClick={() => handleMenuClick('group')}
              >
                Group Analysis
              </MenuItem>
            </MenuContainer>
          </DashboardHeader>
          {vbtDashView === 'overview' && (
          <ViewOnlyOverview token={token} />
          )}
          {vbtDashView === 'group' && (
          <ViewOnlyAnalysis token={token} />
          )}
          {aboutModalShowing && (
          <SharedTemplateAboutModal dashboard='VBT' />
          )}
        </PageWrapper>
      )}
    </Container>
  );
};

export default ViewOnlyVBTDashboard;
